import {createAction, createReducer, createSelector} from '@reduxjs/toolkit';
import {get} from 'lodash-es';
import {getScripInstrument} from '../../../../utils/scripDetail/wave';
import scripDetailsService from '../../../../services/scripDetailService';
import commonBaseService from '../../../../services/commonBaseService';
import {
    API_SEGMENT_ID_MAPPER,
    SCRIP_DETAIL_TAB_LIST,
    SCRIP_DETAILS_TAB_VARIANTS,
    SCRIP_INSTRUMENTS,
    SCRIP_PULL_REFRESH_SCREEN,
} from '../../../../constants/scripDetail';

const MODULE_PREFIX = '[ SCRIP_DETAILS ]';
const EMPTY_OBJECT = {};


const Actions = {
    getFinancialRatio: `${MODULE_PREFIX} getFinancialRatio`,
    setFinancialRatio: `${MODULE_PREFIX} setFinancialRatio`,
    getTrendAnalysis: `${MODULE_PREFIX} getTrendAnalysis`,
    setTrendAnalysis: `${MODULE_PREFIX} setTrendAnalysis`,
    getMfFundHolders: `${MODULE_PREFIX} getMfFundHolders`,
    setMfFundHolders: `${MODULE_PREFIX} setMfFundHolders`,
    getShareHolding: `${MODULE_PREFIX} getShareHolding`,
    setShareHolding: `${MODULE_PREFIX} setShareHolding`,
    getPeerComparison: `${MODULE_PREFIX} getPeerComparison`,
    setPeerComparison: `${MODULE_PREFIX} setPeerComparison`,
    getAnnualReport: `${MODULE_PREFIX} getAnnualReport`,
    setAnnualReport: `${MODULE_PREFIX} setAnnualReport`,
    setScripDetails: `${MODULE_PREFIX} setScripDetails`,
    getSelectedSegment: `${MODULE_PREFIX} getSelectedSegment`,
    setSelectedSegment: `${MODULE_PREFIX} setSelectedSegment`,
    setSelectedSegmentToken: `${MODULE_PREFIX} setSelectedSegmentToken`,
    setScripSymbol: `${MODULE_PREFIX} setScripSymbol`,
    setCurrentEquityToken: `${MODULE_PREFIX} setCurrentEquityToken`,
    getAnalystData: `${MODULE_PREFIX} getAnalystData`,
    setAnalystData: `${MODULE_PREFIX} setAnalystData`,
    getMovingAverage: `${MODULE_PREFIX} getMovingAverage`,
    setMovingAverage: `${MODULE_PREFIX} setMovingAverage`,
    getVolumeDeliveryChart: `${MODULE_PREFIX} getVolumeDeliveryChart`,
    setVolumeDeliveryChart: `${MODULE_PREFIX} setVolumeDeliveryChart`,
    getSecurityInfo: `${MODULE_PREFIX} getSecurityInfo`,
    setSecurityInfo: `${MODULE_PREFIX} setSecurityInfo`,
    getNewsData: `${MODULE_PREFIX} getNewsData`,
    setNewsData: `${MODULE_PREFIX} setNewsData`,
    getBoardMeeting: `${MODULE_PREFIX} getBoardMeeting`,
    setBoardMeeting: `${MODULE_PREFIX} setBoardMeeting`,
    getBookClosure: `${MODULE_PREFIX} getBookClosure`,
    setBookClosure: `${MODULE_PREFIX} setBookClosure`,
    getRights: `${MODULE_PREFIX} getRights`,
    setRights: `${MODULE_PREFIX} setRights`,
    getAgm: `${MODULE_PREFIX} getAgm`,
    setAgm: `${MODULE_PREFIX} setAgm`,
    getEgm: `${MODULE_PREFIX} getEgm`,
    setEgm: `${MODULE_PREFIX} setEgm`,
    getSplit: `${MODULE_PREFIX} getSplit`,
    setSplit: `${MODULE_PREFIX} setSplit`,
    getDividend: `${MODULE_PREFIX} getDividend`,
    setDividend: `${MODULE_PREFIX} setDividend`,
    getBuyback: `${MODULE_PREFIX} getBuyback`,
    setBuyback: `${MODULE_PREFIX} setBuyback`,
    getBonus: `${MODULE_PREFIX} getBonus`,
    setBonus: `${MODULE_PREFIX} setBonus`,
    setSelectedSymbol: `${MODULE_PREFIX} setSelectedSymbol`,
    getConstituentsData: `${MODULE_PREFIX} getConstituentsData`,
    setConstituentsData: `${MODULE_PREFIX} setConstituentsData`,
    getProfitLossAnnualReport: `${MODULE_PREFIX} getProfitLossAnnualReport`,
    getBalanceSheetAnnualReport: `${MODULE_PREFIX} getBalanceSheetAnnualReport`,
    getResultsAnnualReport: `${MODULE_PREFIX} getResultsAnnualReport`,
    setScripDetailsParams: `${MODULE_PREFIX} setScripDetailsParams`,
    setSelectedInstrument: `${MODULE_PREFIX} setSelectedInstrument`,
    setSelectedScripDetailTab: `${MODULE_PREFIX} setSelectedScripDetailTab`,
    setSelectedScripDescription: `${MODULE_PREFIX} setSelectedScripDescription`,
    setAnnualReportProfitData: `${MODULE_PREFIX} setAnnualReportProfitData`,
    setAnnualReportBalanceSheetData: `${MODULE_PREFIX} setAnnualReportBalanceSheetData`,
    setAnnualReportResultsData: `${MODULE_PREFIX} setAnnualReportResultsData`,
    pullRefreshFoScrip: `${MODULE_PREFIX} pullRefreshFoScrip`,
    setPullScripDetailErrorState: `${MODULE_PREFIX} setPullScripDetailErrorState`,
    setPullScripDetailLoadingState: `${MODULE_PREFIX} setPullScripDetailLoadingState`,
    pullRefreshTechnicalScrip: `${MODULE_PREFIX} pullRefreshTechnicalScrip`,
    pullRefreshFundamentalScrip: `${MODULE_PREFIX} pullRefreshFundamentalScrip`,
    pullRefreshNewsEventScrip: `${MODULE_PREFIX} pullRefreshNewsEventScrip`,
    pullRefreshOverviewScrip: `${MODULE_PREFIX} pullRefreshOverviewScrip`,
    pullRefreshConstituentsScrip: `${MODULE_PREFIX} pullRefreshConstituentsScrip`,
    pullRefreshAnalystScrip: `${MODULE_PREFIX} pullRefreshAnalystScrip`,
    fetchScripDetails: `${MODULE_PREFIX} fetchScripDetails`,
    setScripInitialTab: `${MODULE_PREFIX} setScripInitialTab`,
    fetchFnoTabData: `${MODULE_PREFIX} fetchFnoTabData`,
    setFnoTabData: `${MODULE_PREFIX} setFnoTabData`,
    fetchValuation: `${MODULE_PREFIX} fetchValuation`,
    setValuation: `${MODULE_PREFIX} setValuation`,
    setInitialData: `${MODULE_PREFIX} setInitialData`,
};

export const setInitialData = createAction(
    Actions.setInitialData,
);
export const setSelectedInstrument = createAction(
    Actions.setSelectedInstrument,
);
export const setScripDetailsParams = createAction(
    Actions.setScripDetailsParams,
);
export const setSelectedSegment = createAction(Actions.setSelectedSegment);
export const setSelectedSegmentToken = createAction(
    Actions.setSelectedSegmentToken,
);
export const setSelectedScripDescription = createAction(
    Actions.setSelectedScripDescription,
);
export const fetchScripDetails = createAction(Actions.fetchScripDetails);
export const fetchValuation = createAction(Actions.fetchValuation);
export const setValuation = createAction(Actions.setValuation);
export const setScripInitialTab = createAction(
    Actions.setScripInitialTab,
);
export const getFinancialRatio = createAction(Actions.getFinancialRatio);
export const setFinancialRatio = createAction(Actions.setFinancialRatio);
export const getTrendAnalysis = createAction(Actions.getTrendAnalysis);
export const setTrendAnalysis = createAction(Actions.setTrendAnalysis);
export const getMfFundHolders = createAction(Actions.getMfFundHolders);
export const setMfFundHolders = createAction(Actions.setMfFundHolders);
export const getShareHolding = createAction(Actions.getShareHolding);
export const setShareHolding = createAction(Actions.setShareHolding);
export const getAnnualReport = createAction(Actions.getAnnualReport);
export const setAnnualReport = createAction(Actions.setAnnualReport);
export const getPeerComparison = createAction(Actions.getPeerComparison);
export const setPeerComparison = createAction(Actions.setPeerComparison);
export const getAnalystData = createAction(Actions.getAnalystData);
export const setAnalystData = createAction(Actions.setAnalystData);
export const getMovingAverage = createAction(Actions.getMovingAverage);
export const setMovingAverage = createAction(Actions.setMovingAverage);
export const getVolumeDeliveryChart = createAction(
    Actions.getVolumeDeliveryChart,
);
export const setVolumeDeliveryChart = createAction(
    Actions.setVolumeDeliveryChart,
);
export const getSecurityInfo = createAction(Actions.getSecurityInfo);
export const setSecurityInfo = createAction(Actions.setSecurityInfo);
export const getNewsData = createAction(Actions.getNewsData);
export const setNewsData = createAction(Actions.setNewsData);
export const getBoardMeeting = createAction(Actions.getBoardMeeting);
export const setBoardMeeting = createAction(Actions.setBoardMeeting);
export const getBookClosure = createAction(Actions.getBookClosure);
export const setBookClosure = createAction(Actions.setBookClosure);
export const getRights = createAction(Actions.getRights);
export const setRights = createAction(Actions.setRights);
export const getAgm = createAction(Actions.getAgm);
export const setAgm = createAction(Actions.setAgm);
export const getEgm = createAction(Actions.getEgm);
export const setEgm = createAction(Actions.setEgm);
export const getSplit = createAction(Actions.getSplit);
export const setSplit = createAction(Actions.setSplit);
export const getDividend = createAction(Actions.getDividend);
export const setDividend = createAction(Actions.setDividend);
export const getBuyback = createAction(Actions.getBuyback);
export const setBuyback = createAction(Actions.setBuyback);
export const getBonus = createAction(Actions.getBonus);
export const setBonus = createAction(Actions.setBonus);

export const setScripDetails = createAction(Actions.setScripDetails);
export const setSelectedSymbol = createAction(Actions.setSelectedSymbol);
export const setConstituentsData = createAction(Actions.setConstituentsData);
export const getConstituentsData = createAction(Actions.getConstituentsData);
export const getProfitLossAnnualReport = createAction(
    Actions.getProfitLossAnnualReport,
);
export const getBalanceSheetAnnualReport = createAction(
    Actions.getBalanceSheetAnnualReport,
);
export const getResultsAnnualReport = createAction(
    Actions.getResultsAnnualReport,
);
export const setAnnualReportProfitData = createAction(
    Actions.setAnnualReportProfitData,
);
export const setAnnualReportBalanceSheetData = createAction(
    Actions.setAnnualReportBalanceSheetData,
);
export const setAnnualReportResultsData = createAction(
    Actions.setAnnualReportResultsData,
);
export const pullRefreshFoScrip = createAction(Actions.pullRefreshFoScrip);
export const setPullScripDetailErrorState = createAction(
    Actions.setPullScripDetailErrorState,
);
export const setPullScripDetailLoadingState = createAction(
    Actions.setPullScripDetailLoadingState,
);
export const pullRefreshTechnicalScrip = createAction(
    Actions.pullRefreshTechnicalScrip,
);
export const pullRefreshFundamentalScrip = createAction(
    Actions.pullRefreshFundamentalScrip,
);
export const pullRefreshNewsEventScrip = createAction(
    Actions.pullRefreshNewsEventScrip,
);
export const pullRefreshOverviewScrip = createAction(
    Actions.pullRefreshOverviewScrip,
);
export const pullRefreshConstituentsScrip = createAction(
    Actions.pullRefreshConstituentsScrip,
);
export const pullRefreshAnalystScrip = createAction(
    Actions.pullRefreshAnalystScrip,
);
export const fetchFnoTabData = createAction(Actions.fetchFnoTabData);
export const setFnoTabData = createAction(Actions.setFnoTabData);
export const setSelectedScripDetailTab = createAction(
    Actions.setSelectedScripDetailTab,
);



// selector
export const getSelectedScripState = (state, foreignKey) => {
    return get(state, `scripDetails.${foreignKey}`, EMPTY_OBJECT);
};
const getScripDetails = (state) => {
    return get(
        state,
        `scripDetails`,
        EMPTY_OBJECT,
    );
};
export const getSelectedScripDetails = createSelector(
    [getSelectedScripState],
    getScripDetails
);
const getScripTabVariant = (state) => {
    return get(
        state,
        `scripTabVariant`,
        SCRIP_DETAILS_TAB_VARIANTS.EQUITY,
    );
};
export const getSelectedScripTabVariant = createSelector(
    [getSelectedScripState],
    getScripTabVariant
);
const getFinancialRatioData = (state) => {
    return get(
        state,
        `fundamentals.financialRatio`,
        DEFAULT_FINANCIAL_RATIO_DATA,
    );
};
export const getSelectedFinancialRatioData = createSelector(
    [getSelectedScripState],
    getFinancialRatioData
);
const getNSEData = (state) => {
    const scripDetails = getScripDetails(state);
    return get(
        scripDetails,
        `nse_data`,
        {},
    );
};
const getNSEInstrumentType = (state) => {
    const scripDetails = getNSEData(state);
    return get(
        scripDetails,
        `instrument_type`,
        '',
    );
};
const getShouldShowFo = (state) => {
    const nseData = getNSEData(state);
    const nseInstrumentType = getNSEInstrumentType(state);
    if (commonBaseService.isEmptyOrUndefined(nseData)) {
        return false;
    }

    if (nseInstrumentType === SCRIP_INSTRUMENTS.EQUITY) {
        const scripDetails = getScripDetails(state);
        const selectedExchange = get(scripDetails, 'current_exchange', '');
        const selectedExchangeDataKey =
            scripDetailsService.mapExchangeToApiResponseKey(selectedExchange);

        const isFoAvailable = get(
            scripDetails,
            `${selectedExchangeDataKey}.fo_exists`,
            0,
        );
        return Number(isFoAvailable) === 1;
    }
    return true;
};
export const getShouldShowFoTab = createSelector(
    [getSelectedScripState],
    getShouldShowFo
);
const getCurrentScripInitialTab = (state) => {
    return get(
        state,
        'initialTab',
        SCRIP_DETAIL_TAB_LIST.OVERVIEW,
    );
};

export const getScripInitialTab = createSelector(
    [getSelectedScripState],
    getCurrentScripInitialTab
);

const getCurrentSelectedExchangeScripDetails = (state) => {
    const scripDetails = getScripDetails(state);
    const selectedExchange = get(scripDetails, 'current_exchange', '');
    const selectedExchangeDataKey =
        scripDetailsService.mapExchangeToApiResponseKey(selectedExchange);
    return get(
        scripDetails,
        `${selectedExchangeDataKey}`,
        false,
    );
};

export const getSelectedExchangeScripDetails = createSelector(
    [getSelectedScripState],
    getCurrentSelectedExchangeScripDetails
);

const getCurrentSelectedInstrument = (state) => {
    const selectedInstrument = get(state, 'scripInstrument', '');
    return getScripInstrument(selectedInstrument);
};

export const getSelectedInstrument = createSelector(
    [getSelectedScripState],
    getCurrentSelectedInstrument
);

const getCurrentSelectedSegmentToken = (state) => {
    return get(
        state,
        `scripToken`,
        '',
    );
};

export const getSelectedSegmentToken = createSelector(
    [getSelectedScripState],
    getCurrentSelectedSegmentToken
);

const getCurrentSelectedSymbol = (state) => {
    return get(state, 'scripSymbol', '');
};

export const getSelectedSymbol = createSelector(
    [getSelectedScripState],
    getCurrentSelectedSymbol
);

const getCurrentSelectedSegment = (state) => {
    return get(state, `scripSegment`, '');
};

export const getSelectedSegment = createSelector(
    [getSelectedScripState],
    getCurrentSelectedSegment
);

const getCurrentApiSelectedSegmentId = (state) => {
    const selectedSegment = getCurrentSelectedSegment(state);
    return API_SEGMENT_ID_MAPPER[selectedSegment];
};

export const getApiSelectedSegmentId = createSelector(
    [getSelectedScripState],
    getCurrentApiSelectedSegmentId
);

const getIsValuationVisibleForCurrent = (state) => {
    return get(
        state,
        `isValuation`,
        false,
    );
};

export const getIsValuationVisible = createSelector(
    [getSelectedScripState],
    getIsValuationVisibleForCurrent
);

const getCurrentPullScripDetailLoadingState = (state) => {
    return get(
        state,
        'pullScripDetailLoadingState',
        DEFAULT_PULL_REFRESH_STATE,
    );
};

export const getPullScripDetailLoadingState = createSelector(
    [getSelectedScripState],
    getCurrentPullScripDetailLoadingState
);

const getCurrentPullScripDetailErrorState = (state) => {
    return get(
        state,
        'pullScripDetailErrorState',
        DEFAULT_PULL_REFRESH_ERROR_STATE,
    );
};

export const getPullScripDetailErrorState = createSelector(
    [getSelectedScripState],
    getCurrentPullScripDetailErrorState
);

const getSelectedValuationData = (state) => {
    return get(
        state,
        `valuation.valuationData`,
        {},
    );
};

export const getValuationData = createSelector(
    [getSelectedScripState],
    getSelectedValuationData
);

const getCurrentSelectedScripDetailsTab = (state) => {
    return get(
        state,
        'selectedScripDetailTab',
        SCRIP_DETAIL_TAB_LIST.OVERVIEW,
    );
};

export const getSelectedScripDetailsTab = createSelector(
    [getSelectedScripState],
    getCurrentSelectedScripDetailsTab
);

const getSelectedScripIsIndex = (state) => {
    const scripDetails = getScripDetails(state);
    const selectedExchange = get(scripDetails, 'current_exchange', '');
    const selectedExchangeDataKey =
        scripDetailsService.mapExchangeToApiResponseKey(selectedExchange);
    const getIndex = get(
        scripDetails,
        `${selectedExchangeDataKey}.is_index`,
        0,
    );
    const isIndex = Number(getIndex) === 1;
    return isIndex;
};

export const getIsIndex = createSelector(
    [getSelectedScripState],
    getSelectedScripIsIndex
);

const getSelectedFoData = (state) => {
    return get(
        state,
        `fno.futuresListData`,
        {},
    );
};

export const getFoData = createSelector(
    [getSelectedScripState],
    getSelectedFoData
);

const getSelectedScripAnalystData = (state) => {
    return get(
        state,
        `analyst`,
        DEFAULT_INITIAL_OBJECT_DATA,
    );
};

export const getScripAnalystData = createSelector(
    [getSelectedScripState],
    getSelectedScripAnalystData
);

const getSelectedMovingAverageData = (state) => {
    return get(
        state,
        `technical.movingAverage`,
        DEFAULT_MOVING_AVERAGE_DATA,
    );
};

export const getMovingAverageData = createSelector(
    [getSelectedScripState],
    getSelectedMovingAverageData
);

const getSelectedSecurityInfoData = (state) => {
    return get(
        state,
        `technical.securityInfo`,
        DEFAULT_INITIAL_OBJECT_DATA,
    );
};

export const getSecurityInfoData = createSelector(
    [getSelectedScripState],
    getSelectedSecurityInfoData
);

const getSelectedVolumeDeliveryChartData = (state) => {
    return get(
        state,
        `technical.volumeDeliveryChart`,
        DEFAULT_INITIAL_OBJECT_DATA,
    );
};

export const getVolumeDeliveryChartData = createSelector(
    [getSelectedScripState],
    getSelectedVolumeDeliveryChartData
);

const getSelectedTrendAnalysisData = (state) => {
    return get(
        state,
        `fundamentals.trendAnalysis`,
        DEFAULT_INITIAL_OBJECT_DATA,
    );
};

export const getTrendAnalysisData = createSelector(
    [getSelectedScripState],
    getSelectedTrendAnalysisData
);

const getSelectedTopHoldingsData = (state) => {
    return get(
        state,
        `fundamentals.topMfFundHolders`,
        DEFAULT_INITIAL_OBJECT_DATA,
    );
};

export const getTopHoldingsData = createSelector(
    [getSelectedScripState],
    getSelectedTopHoldingsData
);

export const getSelectedShareHoldingData = (state) => {
    return get(
        state,
        `fundamentals.shareHolding`,
        DEFAULT_INITIAL_OBJECT_DATA,
    );
};

export const getShareHoldingData = createSelector(
    [getSelectedScripState],
    getSelectedShareHoldingData
);

export const getSelectedPeerComparisonData = (state) => {
    return get(
        state,
        `fundamentals.peerComparison`,
        DEFAULT_INITIAL_OBJECT_DATA,
    );
};

export const getPeerComparisonData = createSelector(
    [getSelectedScripState],
    getSelectedPeerComparisonData
);

export const getSelectedAnnualReportData = (state) => {
    return get(
        state,
        `fundamentals.annualReport`,
        DEFAULT_ANNUAL_REPORT,
    );
};

export const getAnnualReportData = createSelector(
    [getSelectedScripState],
    getSelectedAnnualReportData
);

export const getSelectedAnnualReportBalanceSheetData = (state) => {
    return get(
        state,
        `fundamentals.annualReport.balanceSheet`,
        DEFAULT_ANNUAL_REPORT.balanceSheet,
    );
};

export const getAnnualReportBalanceSheetData = createSelector(
    [getSelectedScripState],
    getSelectedAnnualReportBalanceSheetData
);


export const getSelectedAnnualReportProfitData = (state) => {
    return get(
        state,
        `fundamentals.annualReport.profitLoss`,
        DEFAULT_ANNUAL_REPORT.profitLoss,
    );
};

export const getAnnualReportProfitData = createSelector(
    [getSelectedScripState],
    getSelectedAnnualReportProfitData
);

export const getSelectedAnnualReportResultsData = (state) => {
    return get(
        state,
        `undamentals.annualReport.results`,
        DEFAULT_ANNUAL_REPORT.results,
    );
};

export const getAnnualReportResultsData = createSelector(
    [getSelectedScripState],
    getSelectedAnnualReportResultsData
);

const getSelectedScripNewsData = (state) => {
    return get(
        state,
        `newsEvents.newsData`,
        DEFAULT_INITIAL_OBJECT_DATA,
    );
};

export const getScripNewsData = createSelector(
    [getSelectedScripState],
    getSelectedScripNewsData
);

const getSelectedBoardMeetingData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.boardMeeting`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getBoardMeetingData = createSelector(
    [getSelectedScripState],
    getSelectedBoardMeetingData
);

export const getCurrentShouldShowConstituentsTab = (state) => {
    const scripDetails = getScripDetails(state);
    const selectedExchange = get(scripDetails, 'current_exchange', '');
    const selectedExchangeDataKey =
        scripDetailsService.mapExchangeToApiResponseKey(selectedExchange);
    const hasConstituent = get(
        scripDetails,
        `${selectedExchangeDataKey}.has_constituents`,
        0,
    );
    return Number(hasConstituent) === 1;
};

export const getShouldShowConstituentsTab = createSelector(
    [getSelectedScripState],
    getCurrentShouldShowConstituentsTab
);

export const getSelectedConstituentsValue = (state) => {
    return get(
        state,
        `constituentsData`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getConstituentsValue = createSelector(
    [getSelectedScripState],
    getSelectedConstituentsValue
);

export const getSelectedRightsData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.rights`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getRightsData = createSelector(
    [getSelectedScripState],
    getSelectedRightsData
);


export const getSelectedBookClosureData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.bookClosure`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getBookClosureData = createSelector(
    [getSelectedScripState],
    getSelectedBookClosureData
);

export const getSelectedAgmData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.agm`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getAgmData = createSelector(
    [getSelectedScripState],
    getSelectedAgmData
);

const getSelectedEgmData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.egm`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getEgmData = createSelector(
    [getSelectedScripState],
    getSelectedEgmData
);

export const getSelectedSplitData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.split`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getSplitData = createSelector(
    [getSelectedScripState],
    getSelectedSplitData
);

export const getSelectedDividendData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.dividend`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getDividendData = createSelector(
    [getSelectedScripState],
    getSelectedDividendData
);

export const getSelectedBuybackData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.buyback`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getBuybackData = createSelector(
    [getSelectedScripState],
    getSelectedBuybackData
);

export const getSelectedBonusData = (state) => {
    return get(
        state,
        `newsEvents.corporateAction.bonus`,
        DEFAULT_INITIAL_ARRAY_DATA,
    );
};

export const getBonusData = createSelector(
    [getSelectedScripState],
    getSelectedBonusData
);

export const getSelectedHoldingsDetails = (state, foreignKey) => {
    const holdingsListData = get(
        state,
        'stocksPortfolio.holdings.data.holdings',
        {},
    );
    const scripDetails = getSelectedExchangeScripDetails(state, foreignKey);
    const selectedHoldingIsin = get(scripDetails, 'isin', '');
    return get(
        holdingsListData,
        `${selectedHoldingIsin}`,
        {},
    );
};

export const REFRESH_STRUCTURE = {
    lastRefreshTime: '',
    freq: '',
    nextRefreshTime: '',
    shouldRefresh: false,
    isUiCacheEnabled: false,
};

// default Initial states
export const DEFAULT_OPTION_EXPIRY_DATA = {
    isLoading: false,
    data: [],
    error: '',
    ...REFRESH_STRUCTURE,
};

export const DEFAULT_NEW_OPTION_CHAIN_DATA = {
    isLoading: false,
    data: {},
    error: '',
    ...REFRESH_STRUCTURE,
};

const DEFAULT_INITIAL_OBJECT_DATA = {
    isLoading: true,
    data: {},
    ...REFRESH_STRUCTURE,
};

const DEFAULT_INITIAL_ARRAY_DATA = {
    isLoading: false,
    data: [],
    ...REFRESH_STRUCTURE,
};

const DEFAULT_FINANCIAL_RATIO_DATA = {
    isLoading: false,
    data: {
        standalone: {},
        consolidated: {},
    },
};

const DEFAULT_ANNUAL_REPORT = {
    isLoading: false,
    profitLoss: {
        data: {
            standalone: [],
            consolidated: [],
        },
    },
    balanceSheet: {
        data: {
            standalone: [],
            consolidated: [],
        },
    },
    results: {
        data: {
            standalone: [],
            consolidated: [],
        },
    },
};

const DEFAULT_MOVING_AVERAGE_DATA = {
    isLoading: false,
    data: {
        NSE: {},
        BSE: {},
    },
};

const DEFAULT_FO_DATA = {
    isLoading: false,
    data: {},
};

const DEFAULT_CORPORATION_DATA = {
    boardMeeting: DEFAULT_INITIAL_ARRAY_DATA,
    bookClosure: DEFAULT_INITIAL_ARRAY_DATA,
    rights: DEFAULT_INITIAL_ARRAY_DATA,
    agm: DEFAULT_INITIAL_ARRAY_DATA,
    egm: DEFAULT_INITIAL_ARRAY_DATA,
    split: DEFAULT_INITIAL_ARRAY_DATA,
    dividend: DEFAULT_INITIAL_ARRAY_DATA,
    buyback: DEFAULT_INITIAL_ARRAY_DATA,
    bonus: DEFAULT_INITIAL_ARRAY_DATA,
};

const DEFAULT_OPTION_DATA = {
    isLoading: false,
    data: {
        pe: {},
        ce: {},
        strikePrices: [],
        pcr: [],
    },
};

export const DEFAULT_OPTION_CHAIN_DATA = {
    isLoading: false,
    data: {},
    expiryDates: [],
};

export const INITIAL_TAB_STRUCTURE = {
    fundamentals: {
        lastRefreshTime: '2022-09-2 12:11:00',
        shouldRefresh: false,
        freq: '2022-09-2 12:11:00',
        isLoading: false,
        healthScore: DEFAULT_INITIAL_OBJECT_DATA,
        financialRatio: DEFAULT_FINANCIAL_RATIO_DATA,
        trendAnalysis: DEFAULT_INITIAL_OBJECT_DATA,
        topMfFundHolders: DEFAULT_INITIAL_OBJECT_DATA,
        shareHolding: DEFAULT_INITIAL_OBJECT_DATA,
        peerComparison: DEFAULT_INITIAL_OBJECT_DATA,
        annualReport: DEFAULT_ANNUAL_REPORT,
    },
    analyst: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        ...DEFAULT_INITIAL_OBJECT_DATA,
    },
    technical: {
        lastRefreshTime: '2022-09-2 12:11:00',
        shouldRefresh: false,
        freq: '2022-09-2 12:11:00',
        movingAverage: DEFAULT_MOVING_AVERAGE_DATA,
        volumeDeliveryChart: DEFAULT_INITIAL_OBJECT_DATA,
        securityInfo: DEFAULT_INITIAL_OBJECT_DATA,
    },
    newsEvents: {
        lastRefreshTime: '2022-09-2 12:11:00',
        shouldRefresh: false,
        freq: '2022-09-2 12:11:00',
        newsData: DEFAULT_INITIAL_OBJECT_DATA,
        corporateAction: DEFAULT_CORPORATION_DATA,
    },
    companyInfo: {
        lastRefreshTime: '2022-09-2 12:11:00',
        shouldRefresh: false,
        freq: '2022-09-2 12:11:00',
        boardOfDirector: DEFAULT_INITIAL_OBJECT_DATA,
        companyInformation: DEFAULT_INITIAL_OBJECT_DATA,
        companyListing: DEFAULT_INITIAL_OBJECT_DATA,
        companyExchange: DEFAULT_INITIAL_OBJECT_DATA,
        contactInformation: DEFAULT_INITIAL_OBJECT_DATA,
    },
    optionChainData: DEFAULT_OPTION_CHAIN_DATA,
    optionExpiryDates: DEFAULT_OPTION_EXPIRY_DATA,
    newOptionChainData: DEFAULT_NEW_OPTION_CHAIN_DATA,
    optionChainMaxPutOi: 0,
    optionChainMaxCallOi: 0,
    constituentsData: DEFAULT_INITIAL_ARRAY_DATA,
    fo: {
        optionSnapshotData: DEFAULT_OPTION_DATA,
    },
};

const COMMON_OPTION_CHAIN_STRUCTURE = {
    optionExpiryDates: DEFAULT_OPTION_EXPIRY_DATA,
    newOptionChainData: DEFAULT_NEW_OPTION_CHAIN_DATA,
    optionChainMaxPutOi: 0,
    optionChainMaxCallOi: 0,
};

const EQUITY_TAB_VARIANT_STRUCTURE = {
    analyst: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        ...DEFAULT_INITIAL_OBJECT_DATA,
    },
    newsEvents: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        newsData: DEFAULT_INITIAL_OBJECT_DATA,
        corporateAction: DEFAULT_CORPORATION_DATA,
    },
    fno: {
        futuresListData: DEFAULT_INITIAL_OBJECT_DATA,
    },
    valuation: {
        valuationData: DEFAULT_INITIAL_OBJECT_DATA,
    },
    fundamentals: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        isLoading: false,
        healthScore: DEFAULT_INITIAL_OBJECT_DATA,
        financialRatio: DEFAULT_FINANCIAL_RATIO_DATA,
        trendAnalysis: DEFAULT_INITIAL_OBJECT_DATA,
        topMfFundHolders: DEFAULT_INITIAL_OBJECT_DATA,
        shareHolding: DEFAULT_INITIAL_OBJECT_DATA,
        peerComparison: DEFAULT_INITIAL_OBJECT_DATA,
        annualReport: DEFAULT_ANNUAL_REPORT,
    },
    technical: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        movingAverage: DEFAULT_MOVING_AVERAGE_DATA,
        volumeDeliveryChart: DEFAULT_INITIAL_OBJECT_DATA,
        securityInfo: DEFAULT_INITIAL_OBJECT_DATA,
    },
    scripDetails: {},
    ...COMMON_OPTION_CHAIN_STRUCTURE,
};

const EQUITY_T2_TAB_VARIANT_STRUCTURE = {
    newsEvents: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        newsData: DEFAULT_INITIAL_OBJECT_DATA,
        corporateAction: DEFAULT_CORPORATION_DATA,
    },
    fundamentals: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        isLoading: false,
        healthScore: DEFAULT_INITIAL_OBJECT_DATA,
        financialRatio: DEFAULT_FINANCIAL_RATIO_DATA,
        trendAnalysis: DEFAULT_INITIAL_OBJECT_DATA,
        topMfFundHolders: DEFAULT_INITIAL_OBJECT_DATA,
        shareHolding: DEFAULT_INITIAL_OBJECT_DATA,
        peerComparison: DEFAULT_INITIAL_OBJECT_DATA,
        annualReport: DEFAULT_ANNUAL_REPORT,
    },
    valuation: {
        valuationData: DEFAULT_INITIAL_OBJECT_DATA,
    },
    technical: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        movingAverage: DEFAULT_MOVING_AVERAGE_DATA,
        volumeDeliveryChart: DEFAULT_INITIAL_OBJECT_DATA,
        securityInfo: DEFAULT_INITIAL_OBJECT_DATA,
    },
    fno: {
        futuresListData: DEFAULT_INITIAL_OBJECT_DATA,
    },
    scripDetails: {},
    ...COMMON_OPTION_CHAIN_STRUCTURE,
};

const ETF_TAB_VARIANT_STRUCTURE = {
    scripDetails: {},
    ...COMMON_OPTION_CHAIN_STRUCTURE,
};

const INDEX_TAB_VARIANT_STRUCTURE = {
    scripDetails: {},
    constituentsData: DEFAULT_INITIAL_ARRAY_DATA,
    fno: {
        futuresListData: DEFAULT_INITIAL_OBJECT_DATA,
    },
    ...COMMON_OPTION_CHAIN_STRUCTURE,
};

const FO_TAB_VARIANT_STRUCTURE = {
    scripDetails: {},
    fno: {
        futuresListData: DEFAULT_INITIAL_OBJECT_DATA,
    },
    ...COMMON_OPTION_CHAIN_STRUCTURE,
};

const SCRIP_TAB_VARIANT_STRUCTURE_MAPPER = {
    [SCRIP_DETAILS_TAB_VARIANTS.EQUITY]: EQUITY_TAB_VARIANT_STRUCTURE,
    [SCRIP_DETAILS_TAB_VARIANTS['EQUITY-T2']]: EQUITY_T2_TAB_VARIANT_STRUCTURE,
    [SCRIP_DETAILS_TAB_VARIANTS.ETF]: ETF_TAB_VARIANT_STRUCTURE,
    [SCRIP_DETAILS_TAB_VARIANTS.FO]: FO_TAB_VARIANT_STRUCTURE,
    [SCRIP_DETAILS_TAB_VARIANTS.INDEX]: INDEX_TAB_VARIANT_STRUCTURE,
};

const COMMON_SEGMENT_STRUCTURE = {
    analyst: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        ...DEFAULT_INITIAL_OBJECT_DATA,
    },
    newsEvents: {
        lastRefreshTime: '',
        shouldRefresh: false,
        freq: '',
        newsData: DEFAULT_INITIAL_OBJECT_DATA,
        corporateAction: DEFAULT_CORPORATION_DATA,
    },
};

const DEFAULT_PULL_REFRESH_STATE = {
    [SCRIP_PULL_REFRESH_SCREEN.OVERVIEW]: false,
    [SCRIP_PULL_REFRESH_SCREEN.ANALYST]: false,
    [SCRIP_PULL_REFRESH_SCREEN.SCRIP_FO]: false,
    [SCRIP_PULL_REFRESH_SCREEN.TECHNICAL]: false,
    [SCRIP_PULL_REFRESH_SCREEN.COMPANY_INFO]: false,
    [SCRIP_PULL_REFRESH_SCREEN.FUNDAMENTAL]: false,
    [SCRIP_PULL_REFRESH_SCREEN.CONSTITUENTS]: false,
    [SCRIP_PULL_REFRESH_SCREEN.OPTION_OVERVIEW]: false,
    [SCRIP_PULL_REFRESH_SCREEN.FUTURE_OVERVIEW]: false,
    [SCRIP_PULL_REFRESH_SCREEN.NEWS_EVENT]: false,
};

const DEFAULT_PULL_REFRESH_ERROR_STATE = {
    status: false,
    errorMessage: '',
};

const initialState = {};

export default createReducer(initialState, (builder) => {
    builder.addCase(setInitialData, (state, action) => {
        const {foreignKey, initialData} = action.payload;
        const {
            scripSymbol,
            scripToken,
            scripSegment,
            scripInstrument,
            scripDescription,
            initialTab,
        } = initialData;

        if (!state[foreignKey]) {
            state[foreignKey] = {};
        }

        state[foreignKey].scripSymbol = scripSymbol;
        state[foreignKey].scripToken = scripToken;
        state[foreignKey].scripSegment = scripSegment;
        state[foreignKey].scripInstrument = scripInstrument;
        state[foreignKey].scripDescription = scripDescription;
        state[foreignKey].initialTab = initialTab;
        state[foreignKey].shouldInitTabStructure = true;
    });
    builder.addCase(setSelectedSegment, (state, action) => {
        const {foreignKey, segment} = action.payload;
        state[foreignKey].scripSegment = segment;
    });
    builder.addCase(setSelectedSegmentToken, (state, action) => {
        const {foreignKey, token} = action.payload;
        state[foreignKey].scripToken = token;
    });
    builder.addCase(setFinancialRatio, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const fundamentalData =
                state[foreignKey]?.fundamentals ||
                INITIAL_TAB_STRUCTURE.fundamentals;
            state[foreignKey].fundamentals.financialRatio =
                {
                    ...fundamentalData.financialRatio,
                    ...rest,
                };
        }
    });
    builder.addCase(setTrendAnalysis, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const fundamentalData =
                state[foreignKey]?.fundamentals ||
                INITIAL_TAB_STRUCTURE.fundamentals;
            state[foreignKey].fundamentals.trendAnalysis =
                {
                    ...fundamentalData.trendAnalysis,
                    ...rest,
                };
        }
    });
    builder.addCase(setMfFundHolders, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const fundamentalData =
                state[foreignKey]?.fundamentals ||
                INITIAL_TAB_STRUCTURE.fundamentals;
            state[foreignKey].fundamentals.topMfFundHolders =
                {
                    ...fundamentalData.topMfFundHolders,
                    ...rest,
                };
        }
    });
    builder.addCase(setShareHolding, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const fundamentalData =
                state[foreignKey]?.fundamentals ||
                INITIAL_TAB_STRUCTURE.fundamentals;
            state[foreignKey].fundamentals.shareHolding =
                {
                    ...fundamentalData.shareHolding,
                    ...rest,
                };
        }
    });
    builder.addCase(setPeerComparison, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const fundamentalData =
                state[foreignKey]?.fundamentals ||
                INITIAL_TAB_STRUCTURE.fundamentals;
            state[foreignKey].fundamentals.peerComparison =
                {
                    ...fundamentalData.peerComparison,
                    ...rest,
                };
        }
    });
    builder.addCase(setAnnualReport, (state, action) => {
        const scripUniqueIdentifier = state.scripUniqueIdentifier;
        if (scripUniqueIdentifier) {
            const fundamentalData =
                state[scripUniqueIdentifier]?.fundamentals ||
                INITIAL_TAB_STRUCTURE.fundamentals;
            const annualReport = {
                ...fundamentalData.annualReport,
                ...action.payload,
            };
            state[scripUniqueIdentifier].fundamentals.annualReport =
                annualReport;
        }
    });
    builder.addCase(setAnnualReportProfitData, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const defaultProfitLossData =
                state[foreignKey].fundamentals.annualReport
                    .profitLoss;
            state[foreignKey].fundamentals.annualReport.profitLoss =
                {
                    ...defaultProfitLossData,
                    ...rest,
                };
        }
    });
    builder.addCase(setAnnualReportBalanceSheetData, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const defaultBalanceSheetData =
                state[foreignKey].fundamentals.annualReport
                    .balanceSheet;
            state[
                foreignKey
                ].fundamentals.annualReport.balanceSheet = {
                ...defaultBalanceSheetData,
                ...rest,
            };
        }
    });
    builder.addCase(setAnnualReportResultsData, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const defaultResultsData =
                state[foreignKey].fundamentals.annualReport.results;
            state[foreignKey].fundamentals.annualReport.results = {
                ...defaultResultsData,
                ...rest,
            };
        }
    });
    builder.addCase(setAnalystData, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const analystData =
                state[foreignKey]?.analyst ||
                COMMON_SEGMENT_STRUCTURE.analyst;
            state[foreignKey].analyst = {...analystData, ...rest};
        }
    });
    builder.addCase(setMovingAverage, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const technicalData =
                state[foreignKey]?.technical ||
                INITIAL_TAB_STRUCTURE.technical;
            state[foreignKey].technical.movingAverage =
                {
                    ...technicalData.movingAverage,
                    ...rest,
                };
        }
    });
    builder.addCase(setVolumeDeliveryChart, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const technicalData =
                state[foreignKey]?.technical ||
                INITIAL_TAB_STRUCTURE.technical;
            state[foreignKey].technical.volumeDeliveryChart =
                {
                    ...technicalData.volumeDeliveryChart,
                    ...rest,
                };
        }
    });
    builder.addCase(setSecurityInfo, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const technicalData =
                state[foreignKey]?.technical ||
                INITIAL_TAB_STRUCTURE.technical;
            const securityInfo = {
                ...technicalData.securityInfo,
                ...rest,
            };
            state[foreignKey].technical.securityInfo = securityInfo;
        }
    });
    builder.addCase(setNewsData, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const newsEventsData =
                state[foreignKey]?.newsEvents ||
                INITIAL_TAB_STRUCTURE.newsEvents;
            state[foreignKey].newsEvents.newsData = {...newsEventsData.newsData, ...rest};
        }
    });
    builder.addCase(setBoardMeeting, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            state[foreignKey].newsEvents.corporateAction.boardMeeting = {
                ...corporateAction.boardMeeting,
                ...rest,
            };
        }
    });
    builder.addCase(setBookClosure, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            state[foreignKey].newsEvents.corporateAction.bookClosure = {
                ...corporateAction.bookClosure,
                ...rest,
            };
        }
    });
    builder.addCase(setRights, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            state[foreignKey].newsEvents.corporateAction.rights =
                {...corporateAction.rights, ...rest};
        }
    });
    builder.addCase(setAgm, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            state[foreignKey].newsEvents.corporateAction.agm = {...corporateAction.agm, ...rest};
        }
    });
    builder.addCase(setEgm, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            state[foreignKey].newsEvents.corporateAction.egm = {...corporateAction.egm, ...rest};
        }
    });
    builder.addCase(setSplit, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            state[foreignKey].newsEvents.corporateAction.split =
                {...corporateAction.split, ...rest};
        }
    });
    builder.addCase(setDividend, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            state[foreignKey].newsEvents.corporateAction.dividend =
                {...corporateAction.dividend, ...rest};
        }
    });
    builder.addCase(setBuyback, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            const buyback = {...corporateAction.buyback, ...rest};
            state[foreignKey].newsEvents.corporateAction.buyback =
                buyback;
        }
    });
    builder.addCase(setBonus, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const corporateAction =
                state[foreignKey]?.newsEvents?.corporateAction ||
                INITIAL_TAB_STRUCTURE.newsEvents.corporateAction;
            state[foreignKey].newsEvents.corporateAction.bonus =
                {...corporateAction.bonus, ...rest};
        }
    });
    builder.addCase(setSelectedSymbol, (state, action) => {
        const {foreignKey, symbol} = action.payload;
        state[foreignKey].scripSymbol = symbol;
    });
    builder.addCase(setConstituentsData, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        if (foreignKey) {
            const constituentsData =
                state[foreignKey]?.constituentsData ||
                INITIAL_TAB_STRUCTURE.constituentsData;
            state[foreignKey].constituentsData = {
                ...constituentsData,
                ...rest,
            };
        }
    });
    builder.addCase(setSelectedInstrument, (state, action) => {
        const {foreignKey, instrument} = action.payload;
        state[foreignKey].scripInstrument = instrument;
    });
    builder.addCase(setSelectedScripDetailTab, (state, action) => {
        const {foreignKey, selectedTab} = action.payload;
        state[foreignKey].selectedScripDetailTab = selectedTab;
    });
    builder.addCase(setSelectedScripDescription, (state, action) => {
        const {foreignKey, description} = action.payload;
        state[foreignKey].selectedScripDescription = description;
    });
    builder.addCase(setPullScripDetailErrorState, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        state[foreignKey].pullScripDetailErrorState = rest;
    });
    builder.addCase(setPullScripDetailLoadingState, (state, action) => {
        const {foreignKey, ...rest} = action.payload;
        const currentState = state[foreignKey].pullScripDetailLoadingState || {};
        state[foreignKey].pullScripDetailLoadingState = {
            ...currentState,
            ...action.payload,
        };
    });
    builder.addCase(setScripDetails, (state, action) => {
        const {scripData, foreignKey} = action.payload;
        const scripLabelId =
            get(scripData, 'nse_data.scrip_label_id', '') ||
            get(scripData, 'bse_data.scrip_label_id', '');
        const selectedExchange = get(scripData, 'current_exchange', '');
        const selectedExchangeKey =
            scripDetailsService.mapExchangeToApiResponseKey(
                selectedExchange,
            );
        const selectedExchangeScripDetails = get(
            scripData,
            `${selectedExchangeKey}`,
            {},
        );
        const isIndexScrip = scripDetailsService.isIndexScrip(
            selectedExchangeScripDetails,
        );
        const scripTabVariant =
            scripDetailsService.mapScripLabelToTabVariant(
                scripLabelId,
                isIndexScrip,
            );
        const isValuationVisible =
            scripDetailsService.isValuationVisible(scripLabelId);

        if (!state[foreignKey]) {
            state[foreignKey] = {};
        }
        if (state[foreignKey].shouldInitTabStructure) {
            const scripVariantReduxStructure =
                SCRIP_TAB_VARIANT_STRUCTURE_MAPPER[scripTabVariant] || {};
            state[foreignKey] = { ...state[foreignKey], ...scripVariantReduxStructure };
            state[foreignKey].shouldInitTabStructure = false;
        }
        state[foreignKey].scripDetails = scripData;
        state[foreignKey].scripTabVariant = scripTabVariant;
        state[foreignKey].isValuation = isValuationVisible;
    });
    builder.addCase(setScripInitialTab, (state, action) => {
        const {foreignKey, tab} = action.payload;
        state[foreignKey].initialTab = tab;
    });
    builder.addCase(setFnoTabData, (state, action) => {
        const {result, foreignKey} = action.payload;
        state[foreignKey].fno.futuresListData.data = result;
    });
    builder.addCase(setValuation, (state, action) => {
        const {result, foreignKey} = action.payload;
        state[foreignKey].valuation.valuationData.data =
            result;
    });
});
